import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { installSdk, bootstrapAuth } from "@/boot/install-sdk";
import { router } from "@/router";
import "@/styles.css";

installSdk();

void bootstrapAuth().finally(() => {
  const el = document.getElementById("root");
  if (!el) throw new Error("#root not found");
  createRoot(el).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
});
